export enum EDealType {
  Sale = 'sale',
  Rent = 'rent',
  Host = 'host',
}

export interface IDealTypeState {
  value: EDealType;
}

export enum EOfferType {
  Apartment = 'apartment',
  Suburban = 'suburban',
}

export interface IOfferTypeState {
  value: EOfferType;
}

export enum EHomeType {
  Apartment = 'apartment',
  House = 'house',
  All = 'all',
}

export type TWantType = {
  id: EDealType;
  text: string;
  imgClass: string;
};
